import { type UseQueryResult, useQuery } from 'react-query';
import { RetirementEligibilityConfigurationService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { CustomerSuccessOptionsAppserviceService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetRoleOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      id: string;
    }>
  | undefined,
  unknown
> => {
  const roleOptions = useQuery(
    ['getRoleOptions'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsSelfRoles()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.customerRoleId ?? '',
            id: item.id ?? '',
          };
        });
      },
    }
  );

  return roleOptions;
};

export default useGetRoleOptions;